module.exports = "/_next/static/images/Privacy-xs@2x-2fbaad76d5c6c6b6d02f66f037d5966e.png";